import script from "./CustomReports.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomReports.vue?vue&type=script&setup=true&lang=js"

import "./CustomReports.vue?vue&type=style&index=0&id=4f7cd294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7cd294"]])

export default __exports__